import React from 'react'

function Social() {
  return (
    <div className="home__social">
        <a href="https://twitter.com/710Mack" className="home__social-icon"  target='_blank'>
            <i className=' uil uil-twitter'></i>
        </a>
        <a href="https://github.com/sujithbk" className="home__social-icon" target='_blank'>
            <i className='uil uil-github-alt'></i>
        </a>
        <a href="https://www.linkedin.com/in/sujith-s-508b21245/" className="home__social-icon" target='_blank'>
            <i className='uil uil-linkedin'></i>
        </a>
    </div>
  )
}

export default Social